import { columnTypes, dataTypes, sortTypes } from 'cat-ecommerce-alloy';
import SavedListLink from './SavedListLink';
import ImportSavedListLink from './ImportSavedListLink';
import ModifiedAndImport from './ModifiedAndImport';

const importSavedListLink = item => {
  return <ImportSavedListLink item={item} />;
};
const nameLink = item => {
  return <SavedListLink item={item} />;
};
const modifiedAndImportMobileCombined = item => {
  return <ModifiedAndImport item={item} />;
};
export const getCustomRenderers = () => ({
  action: importSavedListLink,
  name: nameLink,
  modifiedAndImport: modifiedAndImportMobileCombined
});

export const getTableSchema = t => {
  const displayOnDesktopOnly = 'd-none d-md-table-cell';
  const displayOnMobileOnly = 'd-md-none d-table-cell';
  const displayAll = 'd-table-cell';

  return [
    {
      id: 'name',
      label: t('REQUISITIONLIST_NAME'),
      columnType: columnTypes.STRETCHED,
      isSortable: true,
      sortType: sortTypes.ALPHANUMERIC,
      className: displayAll
    },
    {
      id: 'quantity',
      label: t('REQUISITIONLIST_QUANTITY'),
      columnType: columnTypes.STRETCHED,
      dataType: dataTypes.NUMBER,
      sortType: sortTypes.NUMERIC,
      isSortable: true,
      className: displayAll
    },
    {
      id: 'createdBy',
      label: t('REQUISITIONLIST_CREATOR'),
      columnType: columnTypes.STRETCHED,
      dataType: dataTypes.ALPHANUMERIC,
      isSortable: true,
      sortType: sortTypes.ALPHANUMERIC,
      className: displayOnDesktopOnly
    },
    {
      id: 'updatedDisplayValue',
      label: t('MODIFIED'),
      columnType: columnTypes.STRETCHED,
      dataType: dataTypes.ALPHANUMERIC,
      isSortable: true,

      sortType: sortTypes.NUMERIC,
      sortBy: 'updated',
      className: displayOnDesktopOnly
    },
    {
      id: 'modifiedAndImport',
      label: t('MODIFIED'),
      columnType: columnTypes.STRETCHED,
      dataType: dataTypes.NUMBER,
      isSortable: true,
      sortType: sortTypes.NUMERIC,
      sortBy: 'updated',
      className: displayOnMobileOnly
    },
    {
      id: 'action',
      columnType: columnTypes.STRETCHED,
      className: displayOnDesktopOnly
    }
  ];
};
